import Styled from 'styled-components'

export default Styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 1rem;
`



// WEBPACK FOOTER //
// ./src/components/AuthLinks/index.js